export const frenchPhoneCodes = [
  { name: "France", alphaCode: "FR", internationalCode: "+33" },
  { name: "Saint-Barthélémy", alphaCode: "BL", internationalCode: "+590" },
  { name: "Guyane française", alphaCode: "GF", internationalCode: "+594" },
  { name: "Guadeloupe", alphaCode: "GP", internationalCode: "+590" },
  { name: "Saint-Martin", alphaCode: "MF", internationalCode: "+590" },
  { name: "Martinique", alphaCode: "MQ", internationalCode: "+596" },
  { name: "Polynésie française", alphaCode: "PF", internationalCode: "+689" },
  { name: "Nouvelle-Calédonie", alphaCode: "NC", internationalCode: "+687" },
  { name: "Saint-Pierre-et-Miquelon", alphaCode: "PM", internationalCode: "+508" },
  { name: "La Réunion", alphaCode: "RE", internationalCode: "+262" },
  { name: "Terres Australes et Antarctiques Françaises", alphaCode: "TF", internationalCode: "+262" },
  { name: "Wallis-et-Futuna", alphaCode: "WF", internationalCode: "+681" },
  { name: "Mayotte", alphaCode: "YT", internationalCode: "+262" },
  { name: "Andorre", alphaCode: "AD", internationalCode: "+376" },
  { name: "Monaco", alphaCode: "MC", internationalCode: "+377" },
];

export const neighboringCountryPhoneCodes = [
  { name: "Andorre", alphaCode: "AD", internationalCode: "+376" },
  { name: "Belgique", alphaCode: "BE", internationalCode: "+32" },
  { name: "Suisse", alphaCode: "CH", internationalCode: "+41" },
  { name: "Allemagne", alphaCode: "DE", internationalCode: "+49" },
  { name: "Espagne", alphaCode: "ES", internationalCode: "+34" },
  { name: "Royaume-Uni", alphaCode: "GB", internationalCode: "+44" },
  { name: "Italie", alphaCode: "IT", internationalCode: "+39" },
  { name: "Luxembourg", alphaCode: "LU", internationalCode: "+352" },
  { name: "Monaco", alphaCode: "MC", internationalCode: "+377" },
];

export const europeanPhoneCodes = [
  { name: "Autriche", alphaCode: "AT", internationalCode: "+43" },
  { name: "Bulgarie", alphaCode: "BG", internationalCode: "+359" },
  { name: "Chypre", alphaCode: "CY", internationalCode: "+357" },
  { name: "République tchèque", alphaCode: "CZ", internationalCode: "+420" },
  { name: "Danemark", alphaCode: "DK", internationalCode: "+45" },
  { name: "Estonie", alphaCode: "EE", internationalCode: "+372" },
  { name: "Finlande", alphaCode: "FI", internationalCode: "+358" },
  { name: "Grèce", alphaCode: "GR", internationalCode: "+30" },
  { name: "Croatie", alphaCode: "HR", internationalCode: "+385" },
  { name: "Hongrie", alphaCode: "HU", internationalCode: "+36" },
  { name: "Irlande", alphaCode: "IE", internationalCode: "+353" },
  { name: "Lituanie", alphaCode: "LT", internationalCode: "+370" },
  { name: "Lettonie", alphaCode: "LV", internationalCode: "+371" },
  { name: "Malte", alphaCode: "MT", internationalCode: "+356" },
  { name: "Pays-Bas", alphaCode: "NL", internationalCode: "+31" },
  { name: "Pologne", alphaCode: "PL", internationalCode: "+48" },
  { name: "Portugal", alphaCode: "PT", internationalCode: "+351" },
  { name: "Roumanie", alphaCode: "RO", internationalCode: "+40" },
  { name: "Suède", alphaCode: "SE", internationalCode: "+46" },
  { name: "Slovénie", alphaCode: "SI", internationalCode: "+386" },
  { name: "Slovaquie", alphaCode: "SK", internationalCode: "+421" },
];

// export const otherPhoneCodes = [
//   { name: "Afghanistan", alphaCode: "AF", internationalCode: "+93" },
//   { name: "Afrique du Sud", alphaCode: "ZA", internationalCode: "+27" },
//   { name: "Albanie", alphaCode: "AL", internationalCode: "+355" },
//   { name: "Algérie", alphaCode: "DZ", internationalCode: "+213" },
//   { name: "Allemagne", alphaCode: "DE", internationalCode: "+49" },
//   { name: "Andorre", alphaCode: "AD", internationalCode: "+376" },
//   { name: "Angola", alphaCode: "AO", internationalCode: "+244" },
//   { name: "Anguilla", alphaCode: "AI", internationalCode: "+1264" },
//   { name: "Antigua-et-Barbuda", alphaCode: "AG", internationalCode: "+1268" },
//   { name: "Arabie saoudite", alphaCode: "SA", internationalCode: "+966" },
//   { name: "Argentine", alphaCode: "AR", internationalCode: "+54" },
//   { name: "Arménie", alphaCode: "AM", internationalCode: "+374" },
//   { name: "Aruba", alphaCode: "AW", internationalCode: "+297" },
//   { name: "Australie", alphaCode: "AU", internationalCode: "+61" },
//   { name: "Autriche", alphaCode: "AT", internationalCode: "+43" },
//   { name: "Azerbaïdjan", alphaCode: "AZ", internationalCode: "+994" },
//   { name: "Bahamas", alphaCode: "BS", internationalCode: "+1242" },
//   { name: "Bahreïn", alphaCode: "BH", internationalCode: "+973" },
//   { name: "Bangladesh", alphaCode: "BD", internationalCode: "+880" },
//   { name: "Barbade", alphaCode: "BB", internationalCode: "+1246" },
//   { name: "Belgique", alphaCode: "BE", internationalCode: "+32" },
//   { name: "Bénin", alphaCode: "BJ", internationalCode: "+229" },
//   { name: "Bhoutan", alphaCode: "BT", internationalCode: "+975" },
//   { name: "Biélorussie", alphaCode: "BY", internationalCode: "+375" },
//   { name: "Birmanie (Myanmar)", alphaCode: "MM", internationalCode: "+95" },
//   { name: "Bolivie", alphaCode: "BO", internationalCode: "+591" },
//   { name: "Bosnie-Herzégovine", alphaCode: "BA", internationalCode: "+387" },
//   { name: "Botswana", alphaCode: "BW", internationalCode: "+267" },
//   { name: "Brésil", alphaCode: "BR", internationalCode: "+55" },
//   { name: "Brunei", alphaCode: "BN", internationalCode: "+673" },
//   { name: "Bulgarie", alphaCode: "BG", internationalCode: "+359" },
//   { name: "Burkina Faso", alphaCode: "BF", internationalCode: "+226" },
//   { name: "Burundi", alphaCode: "BI", internationalCode: "+257" },
//   { name: "Cambodge", alphaCode: "KH", internationalCode: "+855" },
//   { name: "Cameroun", alphaCode: "CM", internationalCode: "+237" },
//   { name: "Canada", alphaCode: "CA", internationalCode: "+1" },
//   { name: "Cap-Vert", alphaCode: "CV", internationalCode: "+238" },
//   { name: "Chili", alphaCode: "CL", internationalCode: "+56" },
//   { name: "Chine", alphaCode: "CN", internationalCode: "+86" },
//   { name: "Chypre", alphaCode: "CY", internationalCode: "+357" },
//   { name: "Colombie", alphaCode: "CO", internationalCode: "+57" },
//   { name: "Congo (République du)", alphaCode: "CG", internationalCode: "+242" },
//   { name: "Costa Rica", alphaCode: "CR", internationalCode: "+506" },
//   { name: "Côte d’Ivoire", alphaCode: "CI", internationalCode: "+225" },
//   { name: "Croatie", alphaCode: "HR", internationalCode: "+385" },
//   { name: "Cuba", alphaCode: "CU", internationalCode: "+53" },
//   { name: "Danemark", alphaCode: "DK", internationalCode: "+45" },
//   { name: "Djibouti", alphaCode: "DJ", internationalCode: "+253" },
//   { name: "Égypte", alphaCode: "EG", internationalCode: "+20" },
//   { name: "Émirats arabes unis", alphaCode: "AE", internationalCode: "+971" },
//   { name: "Équateur", alphaCode: "EC", internationalCode: "+593" },
//   { name: "Érythrée", alphaCode: "ER", internationalCode: "+291" },
//   { name: "Espagne", alphaCode: "ES", internationalCode: "+34" },
//   { name: "Estonie", alphaCode: "EE", internationalCode: "+372" },
//   { name: "États-Unis", alphaCode: "US", internationalCode: "+1" },
//   { name: "Éthiopie", alphaCode: "ET", internationalCode: "+251" },
//   { name: "Fidji", alphaCode: "FJ", internationalCode: "+679" },
//   { name: "Finlande", alphaCode: "FI", internationalCode: "+358" },
//   { name: "France", alphaCode: "FR", internationalCode: "+33" },
//   { name: "Gabon", alphaCode: "GA", internationalCode: "+241" },
//   { name: "Gambie", alphaCode: "GM", internationalCode: "+220" },
//   { name: "Géorgie", alphaCode: "GE", internationalCode: "+995" },
//   { name: "Ghana", alphaCode: "GH", internationalCode: "+233" },
//   { name: "Gibraltar", alphaCode: "GI", internationalCode: "+350" },
//   { name: "Grèce", alphaCode: "GR", internationalCode: "+30" },
//   { name: "Grenade", alphaCode: "GD", internationalCode: "+1473" },
//   { name: "Groenland", alphaCode: "GL", internationalCode: "+299" },
//   { name: "Guadeloupe", alphaCode: "GP", internationalCode: "+590" },
//   { name: "Guam", alphaCode: "GU", internationalCode: "+1671" },
//   { name: "Guatemala", alphaCode: "GT", internationalCode: "+502" },
//   { name: "Guernesey", alphaCode: "GG", internationalCode: "+44" },
//   { name: "Guinée", alphaCode: "GN", internationalCode: "+224" },
//   { name: "Guinée-Bissau", alphaCode: "GW", internationalCode: "+245" },
//   { name: "Guinée équatoriale", alphaCode: "GQ", internationalCode: "+240" },
//   { name: "Guyana", alphaCode: "GY", internationalCode: "+592" },
//   { name: "Guyane française", alphaCode: "GF", internationalCode: "+594" },
//   { name: "Haïti", alphaCode: "HT", internationalCode: "+509" },
//   { name: "Honduras", alphaCode: "HN", internationalCode: "+504" },
//   { name: "Hong Kong", alphaCode: "HK", internationalCode: "+852" },
//   { name: "Hongrie", alphaCode: "HU", internationalCode: "+36" },
//   { name: "Inde", alphaCode: "IN", internationalCode: "+91" },
//   { name: "Indonésie", alphaCode: "ID", internationalCode: "+62" },
//   { name: "Irak", alphaCode: "IQ", internationalCode: "+964" },
//   { name: "Iran", alphaCode: "IR", internationalCode: "+98" },
//   { name: "Irlande", alphaCode: "IE", internationalCode: "+353" },
//   { name: "Islande", alphaCode: "IS", internationalCode: "+354" },
//   { name: "Israël", alphaCode: "IL", internationalCode: "+972" },
//   { name: "Italie", alphaCode: "IT", internationalCode: "+39" },
//   { name: "Jamaïque", alphaCode: "JM", internationalCode: "+1876" },
//   { name: "Japon", alphaCode: "JP", internationalCode: "+81" },
//   { name: "Jordanie", alphaCode: "JO", internationalCode: "+962" },
//   { name: "Kazakhstan", alphaCode: "KZ", internationalCode: "+7" },
//   { name: "Kenya", alphaCode: "KE", internationalCode: "+254" },
//   { name: "Kirghizistan", alphaCode: "KG", internationalCode: "+996" },
//   { name: "Kiribati", alphaCode: "KI", internationalCode: "+686" },
//   { name: "Koweït", alphaCode: "KW", internationalCode: "+965" },
//   { name: "Laos", alphaCode: "LA", internationalCode: "+856" },
//   { name: "Lesotho", alphaCode: "LS", internationalCode: "+266" },
//   { name: "Lettonie", alphaCode: "LV", internationalCode: "+371" },
//   { name: "Liban", alphaCode: "LB", internationalCode: "+961" },
//   { name: "Libéria", alphaCode: "LR", internationalCode: "+231" },
//   { name: "Libye", alphaCode: "LY", internationalCode: "+218" },
//   { name: "Liechtenstein", alphaCode: "LI", internationalCode: "+423" },
//   { name: "Lituanie", alphaCode: "LT", internationalCode: "+370" },
//   { name: "Luxembourg", alphaCode: "LU", internationalCode: "+352" },
//   { name: "Macédoine du Nord", alphaCode: "MK", internationalCode: "+389" },
//   { name: "Madagascar", alphaCode: "MG", internationalCode: "+261" },
//   { name: "Malaisie", alphaCode: "MY", internationalCode: "+60" },
//   { name: "Malawi", alphaCode: "MW", internationalCode: "+265" },
//   { name: "Maldives", alphaCode: "MV", internationalCode: "+960" },
//   { name: "Mali", alphaCode: "ML", internationalCode: "+223" },
//   { name: "Malte", alphaCode: "MT", internationalCode: "+356" },
//   { name: "Maroc", alphaCode: "MA", internationalCode: "+212" },
//   { name: "Martinique", alphaCode: "MQ", internationalCode: "+596" },
//   { name: "Maurice", alphaCode: "MU", internationalCode: "+230" },
//   { name: "Mauritanie", alphaCode: "MR", internationalCode: "+222" },
//   { name: "Mayotte", alphaCode: "YT", internationalCode: "+262" },
//   { name: "Mexique", alphaCode: "MX", internationalCode: "+52" },
//   { name: "Moldavie", alphaCode: "MD", internationalCode: "+373" },
//   { name: "Monaco", alphaCode: "MC", internationalCode: "+377" },
//   { name: "Mongolie", alphaCode: "MN", internationalCode: "+976" },
//   { name: "Monténégro", alphaCode: "ME", internationalCode: "+382" },
//   { name: "Mozambique", alphaCode: "MZ", internationalCode: "+258" },
//   { name: "Namibie", alphaCode: "NA", internationalCode: "+264" },
//   { name: "Népal", alphaCode: "NP", internationalCode: "+977" },
//   { name: "Nicaragua", alphaCode: "NI", internationalCode: "+505" },
//   { name: "Niger", alphaCode: "NE", internationalCode: "+227" },
//   { name: "Nigéria", alphaCode: "NG", internationalCode: "+234" },
//   { name: "Norvège", alphaCode: "NO", internationalCode: "+47" },
//   { name: "Nouvelle-Calédonie", alphaCode: "NC", internationalCode: "+687" },
//   { name: "Nouvelle-Zélande", alphaCode: "NZ", internationalCode: "+64" },
//   { name: "Oman", alphaCode: "OM", internationalCode: "+968" },
//   { name: "Ouganda", alphaCode: "UG", internationalCode: "+256" },
//   { name: "Ouzbékistan", alphaCode: "UZ", internationalCode: "+998" },
//   { name: "Pakistan", alphaCode: "PK", internationalCode: "+92" },
//   { name: "Palestine", alphaCode: "PS", internationalCode: "+970" },
//   { name: "Panama", alphaCode: "PA", internationalCode: "+507" },
//   { name: "Papouasie-Nouvelle-Guinée", alphaCode: "PG", internationalCode: "+675" },
//   { name: "Paraguay", alphaCode: "PY", internationalCode: "+595" },
//   { name: "Pays-Bas", alphaCode: "NL", internationalCode: "+31" },
//   { name: "Pérou", alphaCode: "PE", internationalCode: "+51" },
//   { name: "Philippines", alphaCode: "PH", internationalCode: "+63" },
//   { name: "Pologne", alphaCode: "PL", internationalCode: "+48" },
//   { name: "Polynésie française", alphaCode: "PF", internationalCode: "+689" },
//   { name: "Portugal", alphaCode: "PT", internationalCode: "+351" },
//   { name: "Qatar", alphaCode: "QA", internationalCode: "+974" },
//   { name: "République centrafricaine", alphaCode: "CF", internationalCode: "+236" },
//   { name: "République tchèque", alphaCode: "CZ", internationalCode: "+420" },
//   { name: "La Réunion", alphaCode: "RE", internationalCode: "+262" },
//   { name: "Roumanie", alphaCode: "RO", internationalCode: "+40" },
//   { name: "Royaume-Uni", alphaCode: "GB", internationalCode: "+44" },
//   { name: "Russie", alphaCode: "RU", internationalCode: "+7" },
//   { name: "Rwanda", alphaCode: "RW", internationalCode: "+250" },
//   { name: "Saint-Barthélémy", alphaCode: "BL", internationalCode: "+590" },
//   { name: "Saint-Kitts-et-Nevis", alphaCode: "KN", internationalCode: "+1869" },
//   { name: "Saint-Marin", alphaCode: "SM", internationalCode: "+378" },
//   { name: "Saint-Pierre-et-Miquelon", alphaCode: "PM", internationalCode: "+508" },
//   { name: "Saint-Vincent-et-les-Grenadines", alphaCode: "VC", internationalCode: "+1784" },
//   { name: "Sainte-Lucie", alphaCode: "LC", internationalCode: "+1758" },
//   { name: "Salvador", alphaCode: "SV", internationalCode: "+503" },
//   { name: "Samoa", alphaCode: "WS", internationalCode: "+685" },
//   { name: "Sao Tomé-et-Principe", alphaCode: "ST", internationalCode: "+239" },
//   { name: "Sénégal", alphaCode: "SN", internationalCode: "+221" },
//   { name: "Serbie", alphaCode: "RS", internationalCode: "+381" },
//   { name: "Seychelles", alphaCode: "SC", internationalCode: "+248" },
//   { name: "Sierra Leone", alphaCode: "SL", internationalCode: "+232" },
//   { name: "Singapour", alphaCode: "SG", internationalCode: "+65" },
//   { name: "Slovaquie", alphaCode: "SK", internationalCode: "+421" },
//   { name: "Slovénie", alphaCode: "SI", internationalCode: "+386" },
//   { name: "Somalie", alphaCode: "SO", internationalCode: "+252" },
//   { name: "Soudan", alphaCode: "SD", internationalCode: "+249" },
//   { name: "Soudan du Sud", alphaCode: "SS", internationalCode: "+211" },
//   { name: "Sri Lanka", alphaCode: "LK", internationalCode: "+94" },
//   { name: "Suède", alphaCode: "SE", internationalCode: "+46" },
//   { name: "Suisse", alphaCode: "CH", internationalCode: "+41" },
//   { name: "Suriname", alphaCode: "SR", internationalCode: "+597" },
//   { name: "Syrie", alphaCode: "SY", internationalCode: "+963" },
//   { name: "Tadjikistan", alphaCode: "TJ", internationalCode: "+992" },
//   { name: "Taïwan", alphaCode: "TW", internationalCode: "+886" },
//   { name: "Tanzanie", alphaCode: "TZ", internationalCode: "+255" },
//   { name: "Tchad", alphaCode: "TD", internationalCode: "+235" },
//   { name: "Terres Australes et Antarctiques Françaises", alphaCode: "TF", internationalCode: "+262" },
//   { name: "Thaïlande", alphaCode: "TH", internationalCode: "+66" },
//   { name: "Timor oriental", alphaCode: "TL", internationalCode: "+670" },
//   { name: "Togo", alphaCode: "TG", internationalCode: "+228" },
//   { name: "Tonga", alphaCode: "TO", internationalCode: "+676" },
//   { name: "Trinité-et-Tobago", alphaCode: "TT", internationalCode: "+1868" },
//   { name: "Tunisie", alphaCode: "TN", internationalCode: "+216" },
//   { name: "Turkménistan", alphaCode: "TM", internationalCode: "+993" },
//   { name: "Turquie", alphaCode: "TR", internationalCode: "+90" },
//   { name: "Tuvalu", alphaCode: "TV", internationalCode: "+688" },
//   { name: "Ukraine", alphaCode: "UA", internationalCode: "+380" },
//   { name: "Uruguay", alphaCode: "UY", internationalCode: "+598" },
//   { name: "Vanuatu", alphaCode: "VU", internationalCode: "+678" },
//   { name: "Vatican", alphaCode: "VA", internationalCode: "+379" },
//   { name: "Venezuela", alphaCode: "VE", internationalCode: "+58" },
//   { name: "Viêt Nam", alphaCode: "VN", internationalCode: "+84" },
//   { name: "Wallis-et-Futuna", alphaCode: "WF", internationalCode: "+681" },
//   { name: "Yémen", alphaCode: "YE", internationalCode: "+967" },
//   { name: "Zambie", alphaCode: "ZM", internationalCode: "+260" },
//   { name: "Zimbabwe", alphaCode: "ZW", internationalCode: "+263" },
// ];
